import Vue from "vue/dist/vue.esm";
import VueI18n from "vue-i18n";
import { VLazyImagePlugin } from "v-lazy-image";
import 'intersection-observer';
import "@babel/polyfill";
import App from "./App.vue";
import HotelsInfoWithFiltering from "./containers/HotelsInfoWithFiltering.vue";
import FiltersSidebar from "./components/FiltersSidebar.vue";
import HotelList from "./components/HotelList.vue";
import HotelCard from "./components/HotelCard.vue";
import Dropdown from "./components/Dropdown.vue";
document.addEventListener("DOMContentLoaded", () => {
  const VUE_LOCALE = document.querySelector("html").attributes.lang.value;

  // Plugins
  Vue.use(VLazyImagePlugin);
  Vue.use(VueI18n);

  // Instance of translations
  const i18n = new VueI18n({
    locale: VUE_LOCALE,
    messages: window.I18n,
    numberFormats: {}
  });

  // Vue Instance
  const VUE_APP = new Vue({
    i18n,
    el: "#vue-app",
    components: {
      App,
      HotelsInfoWithFiltering,
      FiltersSidebar,
      Dropdown,
      HotelList,
      HotelCard
    }
  });

  Vue.prototype.$locale = VUE_LOCALE;
});
